import React from 'react';
import { useIntl } from 'react-intl';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import AccordionPanel from '@components/common/app-components/AccordionPanel';
import { IAdditionalInfoSectionProps } from '../../types';
import AddressDetailsSection from './AddressDetailsSection';
import EnrolleesTableSection from './EnrolleesTableSection';

// ============================================================================
// Component
// ============================================================================

const AdditionalInfoSection: React.FC<IAdditionalInfoSectionProps> = ({
    enrollment,
}) => {
    const intl = useIntl();

    const {
        homeAddress,
        mailingAddress,
        primaryTaxFilerNames
    } = enrollment;

    return (
        <div className="historical-additional-info">
            <AccordionPanel
                id="additionalInfo"
                ariaControlsId="additionalInfoPanel"
                header={
                    <span className="display-flex flex-align-center text-bold color-link">
                        {intl.formatMessage({ id: 'member.enrollment_list.premiumhistory.additionnalInfo' })}
                    </span>
                }
                isLeftToggle={true}
                expandedIcon={faMinusCircle}
                collapsedIcon={faPlusCircle}
                isHeaderClickable={true}
            >
                <AddressDetailsSection
                    homeAddress={homeAddress}
                    mailingAddress={mailingAddress}
                    primaryTaxFilerNames={primaryTaxFilerNames || []}
                />
                <div className="margin-top-2 padding-top-2">
                    <EnrolleesTableSection enrollment={enrollment} />
                </div>
            </AccordionPanel>
        </div>
    );
};

export default AdditionalInfoSection;
